module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/licenseinfo-55d6c69daef2bc39289a72f85f5dbad6.svg";